import { IPessoaFisica } from "../../PessoaFisica/Componentes/InterfacePessoaFisica";
import { IChaves } from "../../../Interfaces/Interfaces";
import { IAuditoria, ICtrlDoc, IDataHoraCadastroOrDataHoraAtualizacao, IDocumentoArquivo, IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";
import { IDirigenteExcepcionalConsulta } from "../../DirigenteExcepcional/Componentes/InterfaceDirigenteExcepcional";
import { IOutroCargoConsulta } from "../../OutroCargo/Componentes/InterfaceOutroCargo";


export interface IMandatoDirigente {
  dataHoraCadastro?: IDataHoraCadastroOrDataHoraAtualizacao;
  dataHoraAtualizacao?: IDataHoraCadastroOrDataHoraAtualizacao;
  idMandato: number;
  idPessoaFisica: number;
  csCategoria: number;
  nmCargo?: string;
  dtInicioMandato: string;
  dtFimMandato: string;
  dtInicioExercicio: string;
  dtFimExercicio?: string;
  csCondicaoMandato: number;
  csRepresentacao?: number;
  prorrogacao: boolean;
  reconducao: boolean;
  statusReg: number;
  pessoaFisica?: IPessoaFisica;
  entidade?: IEntidade;
  matriculaEfpc?: string;
  habilitacoes: IMandatoHabilitacao[];
  mandatoCaracteristicas: IMandatoCaracteristica[];
  mandatoFuncoesEspeciais?: IMandatoFuncaoEspecial[];
  mandatoSuspensoes?: IMandatoSuspensao[];
  mandatoDocumentos: IDocumentoMandato[];
  situacaoVigencia?: boolean;
  confirmaTrocaDirigenteMaximo?: boolean;
  auditoria?: IAuditoria[];
}

export interface IMandatoHabilitacao {
  idHabilitacao?: number;
  idDocumento?: number;
  documentoChave?: IChaves;
  nuProcesso?: string;
  teNuHabilitacao?: string;
  dtEmissao?: string;
  dtValidade?: string;
  csCondicaoValidade?: number;
  tpCondicaoValidade?: string;
  teObservacao?: string;
  habilitacaoDocsAnalise?: IDocumentoDirigenteHabilitacaoAnalise[];
  habilitacaoDocsEfpc?: IDocumentoDirigenteHabilitacaoEfpc[];
  documentoArquivo?: IDocumentoArquivo;
  statusReg: number;
  emEdicao: boolean; // UTILIZADO PARA CONTROLAR A EDIÇÃO NO MODAL. NÃO EXISTE CAMPO COM ESTE NOME NA TABELA.
  touched: boolean; // UTILIZADO PARA AJUDAR O BECKEND A IDENTIFICAR UM REGISTRO ALTERADO
}

export interface IEnumCondicaoValidade {
  valorEnum: string;
  descricao: string;
  valor: number;
}

export interface IDocumentoDirigenteHabilitacaoAnalise {
  idHabilitacaoDocAnalise?: number;
  idDocumento?: number;
  idCtrlDocTpDoc?: number;
  nmTpDoc?: string;
  nuDocumento?: string;
  dtDocumento?: string;
  documentoChave?: IChaves;
  documentoArquivo?: IDocumentoArquivo;
  ctrlDocTipoDocumento?: ICtrlDoc;
  statusReg: number;
  touched: boolean; // UTILIZADO PARA AJUDAR O BECKEND A IDENTIFICAR UM REGISTRO ALTERADO
}

export interface IDocumentoDirigenteHabilitacaoEfpc {
  idHabilitacaoDocEfpc?: number;
  idDocumento?: number;
  idCtrlDocTpDoc?: number;
  nmTpDoc?: string;
  nuDocumento?: string;
  dtDocumento?: string;
  documentoChave?: IChaves;
  documentoArquivo?: IDocumentoArquivo;
  ctrlDocTipoDocumento?: ICtrlDoc;
  statusReg: number;
  touched: boolean; // UTILIZADO PARA AJUDAR O BECKEND A IDENTIFICAR UM REGISTRO ALTERADO
}

export interface ITipoDocumentoEfpcHabilitacao {
  idTpDocEfpcHabilitacao?: number;
  nmTpDocEfpcHabilitacao?: string;
  dtInicioVigencia?: string;
  dtFimVigencia?: string;
  obrigatorio?: string;
  statusReg: number;
  touched: boolean; // UTILIZADO PARA AJUDAR O BECKEND A IDENTIFICAR UM REGISTRO ALTERADO
}

export interface IMandatoCaracteristica {
  idMandatoCaracteristica?: number;
  idCaracteristicaMandato?: number;
  nmCaracteristica?: string;
  dtInicio?: string;
  dtFim?: string;
  caracteristicasMandato?: ICaracteristicasMandato;
  statusReg: number;
  emEdicao: boolean; // UTILIZADO PARA CONTROLAR A EDIÇÃO NO MODAL. NÃO EXISTE CAMPO COM ESTE NOME NA TABELA.
  touched: boolean; // UTILIZADO PARA AJUDAR O BECKEND A IDENTIFICAR UM REGISTRO ALTERADO
}

export interface IMandatoSuspensao {
  idMandatoSuspensao?: number;
  dtInicio?: string;
  dtFim?: string;
  idDocumento?: number;
  statusReg: number;
  emEdicao: boolean; // UTILIZADO PARA CONTROLAR A EDIÇÃO NO MODAL. NÃO EXISTE CAMPO COM ESTE NOME NA TABELA.
  touched: boolean; // UTILIZADO PARA AJUDAR O BECKEND A IDENTIFICAR UM REGISTRO ALTERADO
}

export interface IDocumentoMandato {
  idMandatoDirigenteDocumento?: number;
  idDocumento?: number;
  idCtrlDocTpDoc: number;
  nmTpDoc: string;
  nmDocumento: string;
  nuDocumento?: string;
  dtDocumento?: string;
  documentoChave?: IChaves;
  documentoArquivo?: IDocumentoArquivo;
  statusReg: number;
  touched: boolean; // UTILIZADO PARA AJUDAR O BECKEND A IDENTIFICAR UM REGISTRO ALTERADO
}

export interface ICaracteristicasMandato {
  idCaracteristicaMandato: number;
  nmCaracteristica: string;
}

export interface IcheckboxGroupOptions {
  label: string;
  value: string;
  disabled?: boolean;
}

export interface IMandatoDirigenteConsulta {
  idMandato: number;
  matricula: string;
  sigla: string;
  nmCargo: string;
  dtInicioMandato: string;
  dtFimMandato?: string;
  dtInicioExercicio?: string;
  dtFimExercicio?: string;
  csCategoria: number;
  categoria: string;
  csCondicaoMandato: number;
  condicao: string;
  csRepresentacao: number;
  idPessoaFisica: number;
  nmPessoaFisica: string;
  nuCpf: string;
  situacaoVigencia?: boolean;
}

export interface IMandatoHistorico {
  idMandatoFuncaoEspecial?: number;
  idFuncaoEspecial?: number;
  nmFuncaoEspecial?: string;
  dtInicio?: string;
  dtFim?: string;
  statusReg: number;
}

export interface IFuncaoEspecialMandato {
  idFuncaoEspecial: number;
  nmFuncaoEspecial: string;
}

export interface IMandatoFuncaoEspecial {
  idMandatoFuncaoEspecial?: number;
  idFuncaoEspecial?: number;
  nmFuncaoEspecial?: string;
  dtInicio?: string;
  dtFim?: string;
  statusReg: number;
  emEdicao: boolean; // UTILIZADO PARA CONTROLAR A EDIÇÃO NO MODAL. NÃO EXISTE CAMPO COM ESTE NOME NA TABELA.
  touched: boolean; // UTILIZADO PARA AJUDAR O BECKEND A IDENTIFICAR UM REGISTRO ALTERADO
}

export interface ICargoConsulta {
  idMandato: number;
  idOutroCargo: number;
  idDirExcepcional: number;
  matricula: string;
  sigla: string;
  nmCargoMandato: string;
  dtInicio?: string;
  dtFim?: string;
  csCategoria: number;
  situacaoVigencia?: boolean;
}

export function converterCargo(mandatosDirigentes: IMandatoDirigenteConsulta[], outrosCargos: IOutroCargoConsulta[], dirigentesExcepcionais: IDirigenteExcepcionalConsulta[]){
    let items: ICargoConsulta[] = [];
    let newItem: ICargoConsulta;

    if (mandatosDirigentes) {
      mandatosDirigentes.forEach((e: IMandatoDirigenteConsulta) => {
        newItem =
        {
          idMandato: e.idMandato,
          idOutroCargo: 0,
          idDirExcepcional: 0,
          matricula: e.matricula,
          sigla: e.sigla,
          nmCargoMandato: e.nmCargo,
          //nmCargoMandato: e.csCategoria === 1 ? e.nmCargo : `CONSELHEIRO ${e.categoria}`,
          dtInicio: e.dtInicioMandato,
          dtFim: e.dtFimMandato,
          csCategoria: e.csCategoria,
          situacaoVigencia: e.situacaoVigencia
        };
        items.push(newItem);
      });
    }

    if (outrosCargos) {
      outrosCargos.forEach((e: IOutroCargoConsulta) => {
        newItem =
        {
          idMandato: 0,
          idOutroCargo: e.idOutroCargo,
          idDirExcepcional: 0,
          matricula: e.matricula,
          sigla: e.sigla,
          nmCargoMandato: e.nmTipoFuncao,
          dtInicio: e.dtInicioAtuacao,
          dtFim: e.dtFimAtuacao,
          csCategoria: 0,
          situacaoVigencia: e.situacaoVigencia
        };
        items.push(newItem);
      });
    }


    if (dirigentesExcepcionais) {
      dirigentesExcepcionais.forEach((e: IDirigenteExcepcionalConsulta) => {
        newItem =
        {
          idMandato: 0,
          idOutroCargo: 0,
          idDirExcepcional: e.idDirExcepcional,
          matricula: e.matricula,
          sigla: e.sigla,
          nmCargoMandato: e.dirigenteExcepcionalFuncao.descricao,
          dtInicio: e.dtInicioAtuacao,
          dtFim: e.dtFimAtuacao,
          csCategoria: 0,
          situacaoVigencia: e.situacaoVigencia
        };
        items.push(newItem);
      });

    }
    return items;
}
